module.exports = __webpack_public_path__ + "static/img/banner3-5.eb34c43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3-5.jpg
// module id = azP4
// module chunks = 1